import classnames from 'classnames'
import React, { Children } from 'react'

import styles from './Track.module.scss'

interface TrackProps {
  header?: React.ReactNode
  footer?: React.ReactNode
  noItemsHint?: React.ReactNode
  isLoading?: boolean
  className?: string
}

export default React.memo(function Track({
  children,
  header,
  footer,
  isLoading,
  noItemsHint,
  className,
}: TrackProps & React.PropsWithChildren) {
  const countChildren = Children.toArray(children).length

  return (
    <section className={classnames(styles.Track, className)}>
      {header && <header>{header}</header>}
      <div className={classnames(styles.itemContainer, { skeleton: isLoading })}>
        {children}
        {!countChildren && <div className={styles.itemSpanFull}>{noItemsHint}</div>}
      </div>
      {footer && <footer>{footer}</footer>}
    </section>
  )
})
